"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrors = void 0;
const baseError_1 = require("../../../models/error/baseError");
class ValidationErrors extends baseError_1.BaseError {
    constructor(errors) {
        super('Validation Errors');
        this.errors = errors;
    }
    getErrors() {
        return this.errors;
    }
}
exports.ValidationErrors = ValidationErrors;
//# sourceMappingURL=ValidationErrors.js.map